const SPECIAL_CHARS = [
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '<',
  '>',
  ':',
  '.',
  ';',
  ',',
  '!',
  '?',
  '§',
  '¨',
  '£',
  '-',
  '_',
  '(',
  ')',
  '{',
  '}',
  '[',
  ']',
  '=',
  '+',
  '|',
  '~',
  '`',
  '\'',
  '°',
  '"',
  '/',
  '\\'];

export function slugify(name, separator = '-', keepEdge = false) {
  if (name && name.toString) {
    return name.toString().toLowerCase().replace(/\s+/g, separator)           // Replace spaces with -
      .replace(new RegExp(`[\\${SPECIAL_CHARS.join('\\')}]+`.replace(`\\${separator}`, ''), 'g'),
        '')       // Remove all non-word chars
      .replace(new RegExp(`\\${separator}\\${separator}+`, 'g'), separator)         // Replace multiple - with single -
      .replace(keepEdge ? null : new RegExp(`^\\${separator}+`), '')             // Trim - from start of text
      .replace(keepEdge ? null : new RegExp(`\\${separator}+$`), '');            // Trim - from end of text
  }
}
